import React, { useState } from "react";
import { WebRtcDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const WebRtcDeveloper = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire expert WebRTC developers in India for real-time communication solutions. Build secure, scalable & high-quality video, voice, and chat apps. Contact now!"/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Expert WebRTC Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-webrtc-developers"/>
<meta property="og:description" content="Hire expert WebRTC developers in India for real-time communication solutions. Build secure, scalable & high-quality video, voice, and chat apps. Contact now!"/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Expert WebRTC Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire expert WebRTC developers in India for real-time communication solutions. Build secure, scalable & high-quality video, voice, and chat apps. Contact now!"/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-webrtc-developers"/>
<title>Hire Expert WebRTC Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10">
          <div className="lg:w-3/4  lg:text-left ">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Expert WebRTC Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              WebRTC development is crucial for businesses aiming to integrate
              real-time communication capabilities into their applications. At
              Ayanshtech, we provide skilled WebRTC developers with expertise in
              building scalable, secure, and feature-rich solutions for video
              conferencing, live streaming, and peer-to-peer communication.
              <br />
              <br />
              Whether you require custom WebRTC applications, integration with
              existing systems, or advanced functionalities like low-latency
              streaming, screen sharing, and multi-party conferencing, our
              developers ensure seamless implementation. Hire WebRTC developers
              from Ayanshtech to deliver cutting-edge real-time communication
              solutions tailored to your business needs.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $16/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
            >
              Hire a WebRTC Developer
            </button>
          </div>
          <div className="flex justify-center mt-5 mb-10 lg:mb-0">
            <img
              src="\assets\images\headerSection\hireWebrtcDev\img1.png"
              alt="WebRTC Development"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Expertise Of Our WebRTC Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Hire WebRTC developers from Ayanshtech with extensive experience in
          delivering real-time communication solutions using advanced WebRTC
          technologies, tailored to meet your unique business needs.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="Custom WebRTC App"
              className="w-10 h-10"
            />
            <p className="text-lg">Custom WebRTC App Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon13.png"
              alt="Real-Time Video"
              className="w-10 h-10"
            />
            <p className="text-lg">Real-Time Video Conferencing Solutions</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon15.png"
              alt="Live Streaming"
              className="w-10 h-10"
            />
            <p className="text-lg">Live Streaming & Broadcasting Services</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon17.png"
              alt="P2P Communication"
              className="w-10 h-10"
            />
            <p className="text-lg">Peer-to-Peer Communication Solutions</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon19.png"
              alt="API Integration"
              className="w-10 h-10"
            />
            <p className="text-lg">WebRTC API Integration & Migration</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon20.png"
              alt="Screen Sharing"
              className="w-10 h-10"
            />
            <p className="text-lg">Screen Sharing & Collaboration Tools</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon18.png"
              alt="Maintenance Services"
              className="w-10 h-10"
            />
            <p className="text-lg">Support & Maintenance Services</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon16.png"
              alt="Social Networking"
              className="w-10 h-10"
            />
            <p className="text-lg">WebRTC-Based Social Networking Platforms</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20 ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Experienced WebRTC Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Hire experienced WebRTC developers from Ayanshtech to create seamless,
          scalable, and secure real-time communication applications tailored to
          your business needs.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="/assets/images/headerSection/hireWebrtcDev/img2.png"
              alt="WebRTC Development Expertise"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="Real-Time Applications"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Develop lightweight, real-time communication applications that
                  are scalable and efficient.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="Secure Communication"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Ensure secure communication with end-to-end encryption and
                  advanced security protocols.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="Custom Solutions"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Create customized WebRTC solutions tailored to your specific
                  business needs and use cases.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="Seamless Integration"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Seamlessly integrate WebRTC APIs into your existing
                  applications for enhanced functionality.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      {/* <div className="max-w-3xl mx-auto p-4 mt-10 w-full ">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {WebRtcDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div> */}

       <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
                FAQs
            </h2>
            <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

                <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
                    {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
                    {WebRtcDevFaqs.map((faq, index) => (
                        <div key={index} className="border-b-2 border-blue-300">
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                                    : ""
                                    }`}
                            >
                                <span className="text-lg">{faq.question}</span>
                                <span className="text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 text-gray-700">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>

                <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
                    {" "}
                    <Contact />
                </div>


            </div>

      <GetInTouch />
    </div>
  </>);
};

export default WebRtcDeveloper;
